((app) => {
    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("Root.Carriers", {
            url: "/Carriers",
            component: "carriers"
        });
    }]);

    app.component("carriers", {
        templateUrl: "/App/States/Carriers/carriers.html",
        controller: carrierCtrl
    });

    carrierCtrl.$inject = ["$q", "carrierMappingApi"];
    function carrierCtrl($q, carrierMappingApi) {
        $ctrl = this;
        $ctrl.ui = { };

        $ctrl.$onInit = () => {
            $ctrl.queryAll();
        };

        $ctrl.queryAll = () => {
            _queryMapped();
            _queryUnmapped();
        };

        $ctrl.refresh = function (component) {
            component === "Mapped" ? _queryMapped() : _queryUnmapped();
        };

        function _queryMapped() {
            $ctrl.ui.mappedLoading = true;
            _throttle(carrierMappingApi.getMappedCarriers())
                .then((results) => {
                    $ctrl.mappedCarriers = results;
                })
                .finally(() => {
                    $ctrl.ui.mappedLoading = false;
                });
        }

        function _queryUnmapped() {
            $ctrl.ui.unmappedLoading = true;
            _throttle(carrierMappingApi.getUnmappedCarriers())
                .then((results) => {
                    $ctrl.unmappedCarriers = results;
                })
                .finally(() => {
                    $ctrl.ui.unmappedLoading = false;
                });
        }

        // When the data loads too fast it doesn't make for a very smooth UX. So
        // we'll throttle that transition.
        // Need to run the api calls with the $q Service. It's integrated into
        // the angular digest cycle so the model will automatically update so
        // the child component doesn't have to worry about watching changes
        function _throttle(promise) {
            return $q((resolve) => {
                setTimeout(() => {
                    return resolve($q.when(promise))
                }, 500);
            });
        }
    }
})(window.app);
